<template>
  <v-container id="grid" fluid grid-list-sm tag="section">
    <v-layout row wrap>
      <v-flex d-flex xs12 order-xs5>
        <v-layout column>
          <v-flex>
            <v-card flat>
              <v-card-text>
                <p>
                  <b>Pago em: </b>
                  {{ $d(getDate(payment.created_at), "dateAndTime") }}
                </p>
                <p><b>Valor: </b> {{ $n(payment.amount, "currency") }}</p>
                <p>
                  <b>Tarifas: </b> - {{ $n(payment.fees_amount, "currency") }}
                </p>
                <p>
                  <b>Valor a receber: </b>
                  {{ $n(amountReceivable(payment), "currency") }}
                </p>
                <p><b>Parcelas: </b> {{ payment.installments }}</p>
                <p><b>Número do P.O.S: </b> {{ payment.terminal_number }}</p>
                <p>
                  <b>Forma de pagamento: </b>
                  {{ $t(`payment_type.${payment.credit}`) }}
                </p>
                <p>
                  <b>Status: </b>
                  <v-chip
                    :class="setClass(payment.status)"
                    small
                    text-color="white"
                  >
                    {{ $t(`status.${payment.status}`) }}
                  </v-chip>
                </p>
                <p>
                  <b>À receber em: </b>
                  {{ $d(getDate(payment.due_on), "short") }}
                </p>
              </v-card-text>
              <!-- <v-card-actions>
                  <v-btn
                      color="indigo darken-2"
                      dark
                      @click.stop="goTo('sales')"
                    >
                    Voltar
                  </v-btn>
                </v-card-actions> -->
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "PaymentContent",
  created() {
    this.$store.dispatch("payments/get", this.$route.params.id);
    this.$store.dispatch("payments/load");
  },
  computed: {
    ...mapGetters({
      payment: "payments/payment",
      isLoading: "payments/loadingData",
    }),
  },
  methods: {
    ...mapActions({
      setCurrentPage: "payments/setCurrentPage",
      setLimit: "payments/setLimit",
    }),
    setClass(status) {
      return `payment ${status}`;
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    amountReceivable(payment) {
      return payment.amount - payment.fees_amount;
    },
    paymentType: (type) => {
      if (type === true) {
        return "credit";
      }
      return "debit";
    },
    getDate(date) {
      return moment(date);
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
    /* DEBUGING METHOD */
    log(value) {
      // console.log(value);
    },
  },
};
</script>
